import { useTranslation } from 'react-i18next'
import { Section } from '../ui/Section'
import { Container } from '../ui/Container'
import { SectionTitle } from '../ui/SectionTitle'
import { SkillCard } from '../ui/SkillCard'

const skillKeys = [
  { key: 'teamBuilding', imageSrc: '/images/general/blog_articolo_01.png' },
  { key: 'technicalSkills', imageSrc: '/images/general/blog_articolo_02.png' },
  { key: 'outsourcingExperience', imageSrc: '/images/general/blog_articolo_03.png' },
  { key: 'qualityCertifications', imageSrc: '/images/general/blog_articolo_04.png' },
  { key: 'technologicalInnovation', imageSrc: '/images/general/blog_articolo_05.png' },
  { key: 'projectManagement', imageSrc: '/images/general/blog_articolo_06.png' },
  { key: 'logisticsSupplyChain', imageSrc: '/images/general/blog_articolo_07.png' },
  { key: 'customComponents', imageSrc: '/images/general/blog_articolo_08.png' },
  { key: 'clientCollaboration', imageSrc: '/images/general/blog_articolo_09.png' },
  { key: 'sustainability', imageSrc: '/images/general/blog_articolo_10.png' },
]

export function SkillsGrid() {
  const { t } = useTranslation()

  return (
    <Section>
      <Container>
        <SectionTitle
          title={t('skills.articles.title')}
          centered
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {skillKeys.map((skill) => (
            <SkillCard
              key={skill.key}
              title={t(`skills.articles.items.${skill.key}.title`)}
              description={t(`skills.articles.items.${skill.key}.description`)}
              imageSrc={skill.imageSrc}
            />
          ))}
        </div>
      </Container>
    </Section>
  )
}
